// extracted by mini-css-extract-plugin
export default {"div":"Services_div__K2umw"};